import {Node} from 'reactflow';

import {FlowchartBaseEdge, FlowchartBaseNode} from '../FlowchartVizConstants';

/**
 * Generic util functions for converting a flowchart to something consumable by ReactFlow
 */
export function findNode(nodes: Array<FlowchartBaseNode>, clientId: string): FlowchartBaseNode | undefined {
  return nodes.find((node) => node.clientId === clientId);
}

export function doesNodeHaveAnInputHandle(node: FlowchartBaseNode, edges: Array<FlowchartBaseEdge>): boolean {
  return edges.find(({toNodeClientId}) => toNodeClientId === node.clientId) != null;
}

export function doesNodeHaveAnOutputHandle(
  node: FlowchartBaseNode,
  edges: Array<FlowchartBaseEdge>
): boolean {
  return edges.find(({fromNodeClientId}) => fromNodeClientId === node.clientId) != null;
}

export function convertNodeForReactFlow<NodeDataType extends FlowchartBaseNode>(
  node: NodeDataType,
  position: {x: number; y: number}
): Node {
  return {
    id: node.clientId,
    data: {...node, layout: {...node.layout, position}},
    position,
  };
}
